/* ============================================================
   Beneos Battlemaps : global header behaviour
   Scrolled state, search overlay, account dropdown, mobile menu,
   touch-friendly Shop mega. Auth state is server-rendered (Liquid
   `customer`), so there is no client login toggle here.
   ============================================================ */
(function () {
  "use strict";
  var nav = document.getElementById("beneos-nav");
  if (!nav) return;

  /* scrolled state over the hero */
  function onScroll() {
    nav.classList.toggle("scrolled", (window.scrollY || document.documentElement.scrollTop) > 40);
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* account dropdown */
  var acctWrap = nav.querySelector("[data-acct-wrap]");
  var acctToggle = nav.querySelector("[data-acct-toggle]");
  if (acctWrap && acctToggle) {
    acctToggle.addEventListener("click", function (e) {
      e.stopPropagation();
      acctWrap.classList.toggle("open");
    });
    document.addEventListener("click", function (e) {
      if (acctWrap.classList.contains("open") && !acctWrap.contains(e.target)) {
        acctWrap.classList.remove("open");
      }
    });
  }

  /* shop mega: hover on desktop (CSS), tap to open on touch/small screens */
  var shopWrap = nav.querySelector("[data-shop-wrap]");
  var shopToggle = nav.querySelector("[data-shop-toggle]");
  if (shopWrap && shopToggle) {
    shopToggle.addEventListener("click", function (e) {
      if (window.matchMedia("(hover: none)").matches) {
        if (!shopWrap.classList.contains("open")) { e.preventDefault(); }
        shopWrap.classList.toggle("open");
      }
    });
    document.addEventListener("click", function (e) {
      if (shopWrap.classList.contains("open") && !shopWrap.contains(e.target)) {
        shopWrap.classList.remove("open");
      }
    });
  }

  /* mobile menu */
  var mobile = document.getElementById("beneos-mobile");
  var burger = nav.querySelector("[data-mobile-toggle]");
  if (mobile && burger) {
    burger.addEventListener("click", function () {
      var open = mobile.classList.toggle("open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  /* search overlay */
  var search = document.getElementById("beneos-search");
  var searchInput = search ? search.querySelector("[data-search-input]") : null;
  function openSearch() {
    if (!search) return;
    search.classList.add("open");
    search.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 80);
  }
  function closeSearch() {
    if (!search) return;
    search.classList.remove("open");
    search.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }
  nav.querySelectorAll("[data-search-open]").forEach(function (b) {
    b.addEventListener("click", openSearch);
  });
  if (search) {
    search.addEventListener("click", function (e) { if (e.target === search) closeSearch(); });
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeSearch();
      if (acctWrap) acctWrap.classList.remove("open");
      if (shopWrap) shopWrap.classList.remove("open");
    }
  });

  /* avatar + display name in the header.
     The avatar is server-rendered from the customer metafield when available; this
     fills it in from the account data (cached per session) otherwise, and keeps the
     dropdown name in sync with the cloud display name. */
  if (acctWrap) {
    var applyAcct = function (d) {
      if (!d) return;
      if (d.avatar_url) {
        nav.querySelectorAll(".nav-avatar, .acct-head .ah-av").forEach(function (el) {
          if (el.querySelector("img")) return;
          el.classList.add("has-img");
          var img = document.createElement("img");
          img.src = d.avatar_url; img.alt = ""; img.width = 38; img.height = 38;
          el.textContent = ""; el.appendChild(img);
        });
      }
      if (d.full_name) {
        var n = nav.querySelector(".acct-head .ah-n"); if (n) n.textContent = d.full_name;
        var sub = document.querySelector(".lib-hero-inner .sub[data-greet]");
        if (sub) sub.textContent = sub.getAttribute("data-greet").replace("__NAME__", d.full_name);
      }
    };
    var cachedAcct = null;
    try { cachedAcct = JSON.parse(sessionStorage.getItem("beneos_acct_v1") || "null"); } catch (e) {}
    if (cachedAcct) applyAcct(cachedAcct);
    if (!cachedAcct) {
      fetch("/apps/beneos/library?resource=connections", { headers: { "Accept": "application/json" }, credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var d = j && j.data; if (!d) return;
          try { sessionStorage.setItem("beneos_acct_v1", JSON.stringify({ avatar_url: d.avatar_url || "", full_name: d.full_name || "" })); } catch (e) {}
          applyAcct(d);
        })
        .catch(function () {});
    }
  }
})();
